const funds = [
  {
    name: "Stronger Country Communities Fund",
    icon: "/img/icon-1.svg",
    pin: "/img/pins/pin-1.svg",
  },
  {
    name: "Growing Local Economies Fund",
    icon: "/img/icon-2.svg",
    pin: "/img/pins/pin-2.svg",
  },
  {
    name: "Resources for Regions Fund",
    icon: "/img/icon-3.svg",
    pin: "/img/pins/pin-3.svg",
  },
  {
    name: "Regional Sports Infrastructure Fund",
    icon: "/img/icon-4.svg",
    pin: "/img/pins/pin-4.svg",
  },
  {
    name: "Regional Cultural Fund",
    icon: "/img/icon-5.svg",
    pin: "/img/pins/pin-5.svg",
  },
  {
    name: "Connecting Country Communities Fund",
    icon: "/img/icon-6.svg",
    pin: "/img/pins/pin-6.svg",
  },
  {
    name: "Fixing Country Roads",
    icon: "/img/icon-7.svg",
    pin: "/img/pins/pin-7.svg",
  },
  {
    name: "Fixing Country Rail",
    icon: "/img/icon-8.svg",
    pin: "/img/pins/pin-8.svg",
  },
  {
    name: "Safe and Secure Water",
    icon: "/img/icon-9.svg",
    pin: "/img/pins/pin-9.svg",
  },
  {
    name: "Mobile Black Spots Program",
    icon: "/img/icon-10.svg",
    pin: "/img/pins/pin-10.svg",
  },
  {
    name: "Regional Growth - Environment and Tourism Fund",
    icon: "/img/icon-11.svg",
    pin: "/img/pins/pin-11.svg",
  },
  {
    name: "NSW Regional Communities Development Fund",
    icon: "/img/icon-12.svg",
    pin: "/img/pins/pin-12.svg",
  },
  {
    name: "Bushfire Local Economic Recovery Fund – BIRP Sector Development Grants",
    icon: "/img/BIRP.svg",
    pin: "/img/pins/BIRP-pin.svg",
  },
  {
    name: "Drought Stimulus Package",
    icon: "/img/DSP-icon.svg",
    pin: "/img/pins/DSP-pin.svg",
  },
  {
    name: "Bushfire Community Recovery and Resilience Fund",
    icon: "/img/BCRER.svg",
    pin: "/img/pins/BCRER-pin.svg",
  },
  {
    name: "Bushfire Local Economic Recovery Fund – Fast-tracked projects",
    icon: "/img/BLER.svg",
    pin: "/img/pins/BLER-pin.svg",
  },
  {
    name: "Regional Events Acceleration Fund",
    icon: "/img/REAF.svg",
    pin: "/img/pins/REAF-pin.svg",
  },
  {
    name: "Bushfire Local Economic Recovery Fund",
    icon: "/img/BLER2.svg",
    pin: "/img/pins/BLER2-pin.svg",
  },
];

const iconsByFundName = funds.reduce((acc, fund) => {
  acc[fund.name] = fund.icon;
  return acc;
}, {});
const pinsByFundName = funds.reduce((acc, fund) => {
  acc[fund.name] = fund.pin;
  return acc;
}, {});
export const fundByName = funds.reduce((acc, fund) => {
  acc[fund.name] = fund;
  return acc;
}, {});
// Use black pin as default
export const getIcon = (fundName) => {
  return iconsByFundName[fundName] || "/img/black-pin.svg";
};
export const getPin = (fundName) => {
  return pinsByFundName[fundName] || "/img/black-pin.svg";
};



// WEBPACK FOOTER //
// ./src/modules/fund.js